<!--Double navigation-->
<!-- Sidenav -->
<div class="side-nav white">
  <!-- Side navigation links -->
  <div class="side-nav-links">
    @if (checkVersion() == 'v3.0.0') {
      <ul class="collapsible collapsible-accordion mt-0 d-none d-xl-block">
        <!-- {{generalTranslation.Menu}} -->
        <li class="no-collase" (click)="sideMenuClick('menuclose')">
          <a id="closeMenu" title="{{generalTranslation.CloseMenu}}">
            <svg class="svgicon icon-close">
              <use xlink:href="assets/images/icons/symbol-defs.svg#icon-close"></use>
            </svg>
            <span class="ms-2 sidemenu-label">&nbsp;</span>
          </a>
        </li>
        <li class="no-collase menu-expand-wrapper" (click)="sideMenuClick('menuexpand')">
          <a id="expandMenu" title="{{generalTranslation.Expand}}">
            <svg class="svgicon icon-menuexpand">
              <use xlink:href="assets/images/icons/symbol-defs.svg#icon-menuexpand"></use>
            </svg>
            <span class="ms-2 sidemenu-label">&nbsp;</span>
          </a>
        </li>
        <li>
          @if (isEdgeHomeInspector||isHpcCountryAdmin || userRole === 'Administrator') {
            <a [class.active]="toolType == 'HomeInspection'" routerLink="/project/homeInspection" (click)="redirect('HomeInspection','collapsed')"
              id="menuHomes" title="Home Prescriptive Certification">
              <svg class="svgicon icon-homeInspection">
                <use xlink:href="assets/images/icons/symbol-defs.svg#icon-homeInspection"></use>
              </svg>
              <span class="ms-2 sidemenu-label">Home Prescriptive Certification</span>
            </a>
          }
        </li>
        <li>
          <a [class.active]="toolType == 'Homes'" routerLink="/project/allBuildings" (click)="redirect('Homes','collapsed')"
            id="menuHomes" title="{{generalTranslation.Homes}}">
            <svg class="svgicon icon-homes">
              <use xlink:href="assets/images/icons/symbol-defs.svg#icon-homes"></use>
            </svg>
            <span class="ms-2 sidemenu-label">{{generalTranslation.Homes}}</span>
          </a>
        </li>
        <li>
          <a [class.active]="toolType == 'Apartments'" routerLink="/project/allBuildings" (click)="redirect('Apartments','collapsed')" id="menuApartments"
            title="{{generalTranslation.Apartments}}">
            <svg class="svgicon icon-education svg-apartments">
              <use xlink:href="assets/images/icons/symbol-defs.svg#icon-apartments"></use>
            </svg>
            <span class="ms-2 sidemenu-label">{{generalTranslation.Apartments}}</span>
          </a>
        </li>
        <li>
          <a [class.active]="toolType == 'Serviced Apartment'" routerLink="/project/allBuildings" (click)="redirect('Serviced Apartment','collapsed')" id="menuServiceApartments"
            title="{{generalTranslation['Serviced Apartment']}}">
            <svg class="svgicon icon-education newsvg">
              <use xlink:href="assets/images/icons/symbol-defs.svg#service-apartments"></use>
            </svg>
            <span class="ms-2 sidemenu-label">{{generalTranslation['Serviced Apartment']}}</span>
          </a>
        </li>
        <li>
          <a [class.active]="toolType == 'Hotel'" routerLink="/project/allBuildings" (click)="redirect('Hotel','collapsed')"
            id="menuHospitality" title="{{generalTranslation.hotelv3}}">
            <svg class="svgicon icon-hospitality">
              <use xlink:href="assets/images/icons/symbol-defs.svg#icon-hospitality"></use>
            </svg>
            <span class="ms-2 sidemenu-label">{{generalTranslation.hotelv3}}</span>
          </a>
        </li>
        <li>
          <a [class.active]="toolType == 'Resort'" routerLink="/project/allBuildings" (click)="redirect('Resort','collapsed')" id="menuResort" title="{{generalTranslation.Resort}}">
            <svg class="svgicon icon-education svg-resort">
              <use xlink:href="assets/images/icons/symbol-defs.svg#icon-resort"></use>
            </svg>
            <span class="ms-2 sidemenu-label">{{generalTranslation.Resort}}</span>
          </a>
        </li>
        <li>
          <a [class.active]="toolType == 'Retail'" routerLink="/project/allBuildings" (click)="redirect('Retail','collapsed')"
            id="menuRetail" title="{{generalTranslation.Retail}}">
            <svg class="svgicon icon-retail">
              <use xlink:href="assets/images/icons/symbol-defs.svg#icon-retail"></use>
            </svg>
            <span class="ms-2 sidemenu-label">{{generalTranslation.Retail}}</span>
          </a>
        </li>
        <li>
          <a [class.active]="toolType == 'Industrial'" style="padding-left: 12px;" routerLink="/project/allBuildings" (click)="redirect('Industrial','collapsed')" id="menuIndustry"
            title="{{generalTranslation.Industrial}}">
            <svg class="svgicon icon-education svg-industry">
              <use xlink:href="assets/images/icons/symbol-defs.svg#icon-industry"></use>
            </svg>
            <span class="ms-2 sidemenu-label">{{generalTranslation.Industrial}}</span>
          </a>
        </li>
        <li>
          <a [class.active]="toolType == 'Office'" routerLink="/project/allBuildings" (click)="redirect('Office','collapsed')"
            id="menuOffices" title="{{generalTranslation.officev3}}">
            <svg class="svgicon icon-offices">
              <use xlink:href="assets/images/icons/symbol-defs.svg#icon-offices"></use>
            </svg>
            <span class="ms-2 sidemenu-label">{{generalTranslation.officev3}}</span>
          </a>
        </li>
        <li>
          <a [class.active]="toolType == 'Healthcare'" routerLink="/project/allBuildings" (click)="redirect('Healthcare','collapsed')"
            id="menuHealth" title="{{generalTranslation.healthcare}}">
            <svg class="svgicon icon-health">
              <use xlink:href="assets/images/icons/symbol-defs.svg#icon-health"></use>
            </svg>
            <span class="ms-2 sidemenu-label">{{generalTranslation.healthcare}}</span>
          </a>
        </li>
        <li>
          <a [class.active]="toolType == 'Education'" routerLink="/project/allBuildings" (click)="redirect('Education','collapsed')" id="menuEducation"
            title="{{generalTranslation.Education}}">
            <svg class="svgicon icon-education">
              <use xlink:href="assets/images/icons/symbol-defs.svg#icon-education"></use>
            </svg>
            <span class="ms-2 sidemenu-label">{{generalTranslation.Education}}</span>
          </a>
        </li>
        <li>
          <a [class.active]="toolType == 'Mixed Use'" style="padding-left: 12px" routerLink="/project/allBuildings" (click)="redirect('Mixed Use','collapsed')" id="menuMixuse" title="{{generalTranslation['Mixed Use']}}">
            <svg class="svgicon icon-education svg-mixuse">
              <use xlink:href="assets/images/icons/symbol-defs.svg#icon-mixeduse"></use>
            </svg>
            <span class="ms-2 sidemenu-label">{{generalTranslation['Mixed Use']}}</span>
          </a>
        </li>
        <!--<li *ngIf="displayVersion == '3.0.0'">
        <div class="MobileMenuAccordion ExpandMenuAccordion">
          <mat-accordion [multi]="true">
            <mat-expansion-panel [expanded]="false">
              <mat-expansion-panel-header>
                <mat-panel-title><svg class="svgicon icon-homes">
                  <use xlink:href="assets/images/icons/symbol-defs.svg#buildingType"></use>
                </svg>
                <span class="ms-2 sidemenu-label">More Building</span></mat-panel-title>
              </mat-expansion-panel-header>
              <a [class.active]="toolType == 'Apartments'"  href="javascript:void(0)" (click)="redirect('Apartments','collapsed')" id="menuApartments"
                title="Apartments">
                <svg class="svgicon icon-education newsvg">
                  <use xlink:href="assets/images/icons/symbol-defs.svg#icon-apartments"></use>
                </svg>
                <span class="ms-2 sidemenu-label">Apartments</span>
              </a>
              <a [class.active]="toolType == 'Industry'" href="javascript:void(0)" (click)="redirect('Industry','collapsed')" id="menuIndustry"
                title="Industry">
                <svg class="svgicon icon-education newsvg">
                  <use xlink:href="assets/images/icons/symbol-defs.svg#icon-industry"></use>
                </svg>
                <span class="ms-2 sidemenu-label">Industry</span>
              </a>
              <a [class.active]="toolType == 'Resort'" href="javascript:void(0)" (click)="redirect('Resort','collapsed')" id="menuResort" title="Resort">
                <svg class="svgicon icon-education newsvg">
                  <use xlink:href="assets/images/icons/symbol-defs.svg#icon-resort"></use>
                </svg>
                <span class="ms-2 sidemenu-label">Resort</span>
              </a>
              <a [class.active]="toolType == 'Service_Apartment'" href="javascript:void(0)" (click)="redirect('Service_Apartment','collapsed')" id="menuServiceApartments"
                title="Service_Apartment">
                <svg class="svgicon icon-education newsvg">
                  <use xlink:href="assets/images/icons/symbol-defs.svg#service-apartments"></use>
                </svg>
                <span class="ms-2 sidemenu-label">Service Apartments</span>
              </a>
              <a [class.active]="toolType == 'Mixuse'" href="javascript:void(0)" (click)="redirect('Mixuse','collapsed')" id="menuMixuse" title="Mixuse">
                <svg class="svgicon icon-education newsvg">
                  <use xlink:href="assets/images/icons/symbol-defs.svg#icon-mixeduse"></use>
                </svg>
                <span class="ms-2 sidemenu-label">Mixuse</span>
              </a>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </li>-->
      <li class="pt-4 d-xl-none border-top mobileQuicklinktxt">
        <h6 class="ms-3 sidemenu-label text-high-emphasis">
          Quick Links
        </h6>
      </li>
      <!--<li class="d-block d-xl-none">
      <a (click)="navigateToAlphaSite()" title="{{generalTranslation.OldInterface}}">
        <svg class="svgicon icon-education">
          <use xlink:href="assets/images/icons/symbol-defs.svg#switch-arrow"></use>
        </svg>
        <span class="ms-2 sidemenu-label">{{generalTranslation.OldInterface}}</span>
      </a>
    </li>-->
    <li class="d-block d-xl-none">
      <a (click)="navigateToWordpress()" title="{{generalTranslation.Homepage}}">
        <svg class="svgicon icon-education">
          <use xlink:href="assets/images/icons/symbol-defs.svg#web-edge"></use>
        </svg>
        <span class="ms-2 sidemenu-label">{{generalTranslation.Homepage}}</span>
      </a>
    </li>
    <li class="pt-4 d-xl-none border-top mobileQuicklinktxt">
      <h6 class="ms-3 sidemenu-label text-high-emphasis">
        Language Preference
      </h6>
    </li>
    <ifc-dropdown-menu [menuItems]="languages" [selectedMenu]="userPersistenceService.selectedLanguage"
      (onMenuClick)="onLanguageChange($event)" class="d-block d-xl-none mobileOnlydropdwn">
    </ifc-dropdown-menu>
  </ul>
}

@if (checkVersion() != 'v3.0.0') {
  <ul class="collapsible collapsible-accordion mt-0 d-none d-xl-block">
    <!-- {{generalTranslation.Menu}} -->
    <li class="no-collase" (click)="sideMenuClick('menuclose')">
      <a id="closeMenu" title="{{generalTranslation.CloseMenu}}">
        <svg class="svgicon icon-close">
          <use xlink:href="assets/images/icons/symbol-defs.svg#icon-close"></use>
        </svg>
        <span class="ms-2 sidemenu-label">&nbsp;</span>
      </a>
    </li>
    <li class="no-collase menu-expand-wrapper" (click)="sideMenuClick('menuexpand')">
      <a id="expandMenu" title="{{generalTranslation.Expand}}">
        <svg class="svgicon icon-menuexpand">
          <use xlink:href="assets/images/icons/symbol-defs.svg#icon-menuexpand"></use>
        </svg>
        <span class="ms-2 sidemenu-label">&nbsp;</span>
      </a>
    </li>
    <li>
      <a routerLinkActive="active" routerLink="/project/homes" (click)="sideMenuClick('collapsed')"
        id="menuHomes" title="{{generalTranslation.Homes}}">
        <svg class="svgicon icon-homes">
          <use xlink:href="assets/images/icons/symbol-defs.svg#icon-homes"></use>
        </svg>
        <span class="ms-2 sidemenu-label">{{generalTranslation.Homes}}</span>
      </a>
    </li>
    <li>
      <a routerLinkActive="active" routerLink="/project/hospitality" (click)="sideMenuClick('collapsed')"
        id="menuHospitality" title="{{generalTranslation.TitleHotels}}">
        <svg class="svgicon icon-hospitality">
          <use xlink:href="assets/images/icons/symbol-defs.svg#icon-hospitality"></use>
        </svg>
        <span class="ms-2 sidemenu-label">{{generalTranslation.TitleHotels}}</span>
      </a>
    </li>
    <li>
      <a routerLinkActive="active" routerLink="/project/retail" (click)="sideMenuClick('collapsed')"
        id="menuRetail" title="{{generalTranslation.Retail}}">
        <svg class="svgicon icon-retail">
          <use xlink:href="assets/images/icons/symbol-defs.svg#icon-retail"></use>
        </svg>
        <span class="ms-2 sidemenu-label">{{generalTranslation.Retail}}</span>
      </a>
    </li>
    <li>
      <a routerLinkActive="active" routerLink="/project/offices" (click)="sideMenuClick('collapsed')"
        id="menuOffices" title="{{generalTranslation.Offices}}">
        <svg class="svgicon icon-offices">
          <use xlink:href="assets/images/icons/symbol-defs.svg#icon-offices"></use>
        </svg>
        <span class="ms-2 sidemenu-label">{{generalTranslation.Offices}}</span>
      </a>
    </li>
    <li>
      <a routerLinkActive="active" routerLink="/project/hospitals" (click)="sideMenuClick('collapsed')"
        id="menuHealth" title="{{generalTranslation.Hospitals}}">
        <svg class="svgicon icon-health">
          <use xlink:href="assets/images/icons/symbol-defs.svg#icon-health"></use>
        </svg>
        <span class="ms-2 sidemenu-label">{{generalTranslation.Hospitals}}</span>
      </a>
    </li>
    <li>
      <a routerLinkActive="active" routerLink="/project/education" id="menuEducation"
        title="{{generalTranslation.Education}}" (click)="sideMenuClick('collapsed')">
        <svg class="svgicon icon-education">
          <use xlink:href="assets/images/icons/symbol-defs.svg#icon-education"></use>
        </svg>
        <span class="ms-2 sidemenu-label">{{generalTranslation.Education}}</span>
      </a>
    </li>
    <!-- <li>
    <a routerLinkActive="active" href="javascript:void(0)" id="menuAllBuildings"
      title={{generalTranslation.Education}} (click)="sideMenuClick('collapsed')">
      <svg class="svgicon icon-education">
        <use xlink:href="assets/images/icons/symbol-defs.svg#icon-education"></use>
      </svg>
      <span class="ms-2 sidemenu-label">{{generalTranslation.Education}}</span>
    </a>
  </li> -->
  <!--
  <li>
    <a routerLinkActive="active" href="javascript:void(0)" id="menuAllBuildings"
      title="Apartments" (click)="sideMenuClick('collapsed')">
      <svg class="svgicon icon-education newsvg">
        <use xlink:href="assets/images/icons/symbol-defs.svg#icon-apartments"></use>
      </svg>
      <span class="ms-2 sidemenu-label">Apartments</span>
    </a>
  </li>
  <li>
    <a routerLinkActive="active" href="javascript:void(0)" id="menuAllBuildings"
      title="Industry" (click)="sideMenuClick('collapsed')">
      <svg class="svgicon icon-education newsvg">
        <use xlink:href="assets/images/icons/symbol-defs.svg#icon-industry"></use>
      </svg>
      <span class="ms-2 sidemenu-label">Industry</span>
    </a>
  </li>
  <li>
    <a routerLinkActive="active" href="javascript:void(0)" id="menuAllBuildings"
      title="Resort" (click)="sideMenuClick('collapsed')">
      <svg class="svgicon icon-education newsvg">
        <use xlink:href="assets/images/icons/symbol-defs.svg#icon-resort"></use>
      </svg>
      <span class="ms-2 sidemenu-label">Resort</span>
    </a>
  </li>
  <li>
    <a routerLinkActive="active" href="javascript:void(0)" id="menuAllBuildings"
      title="Service Apartments" (click)="sideMenuClick('collapsed')">
      <svg class="svgicon icon-education newsvg">
        <use xlink:href="assets/images/icons/symbol-defs.svg#service-apartments"></use>
      </svg>
      <span class="ms-2 sidemenu-label">Service Apartments</span>
    </a>
  </li>
  <li>
    <a routerLinkActive="active" href="javascript:void(0)" id="menuAllBuildings"
      title="Mixuse" (click)="sideMenuClick('collapsed')">
      <svg class="svgicon icon-education newsvg">
        <use xlink:href="assets/images/icons/symbol-defs.svg#icon-mixeduse"></use>
      </svg>
      <span class="ms-2 sidemenu-label">Mixuse</span>
    </a>
  </li> -->
  <li class="pt-4 d-xl-none border-top mobileQuicklinktxt">
    <h6 class="ms-3 sidemenu-label text-high-emphasis">
      Quick Links
    </h6>
  </li>
  <!--<li class="d-block d-xl-none">
  <a (click)="navigateToAlphaSite()" title="{{generalTranslation.OldInterface}}">
    <svg class="svgicon icon-education">
      <use xlink:href="assets/images/icons/symbol-defs.svg#switch-arrow"></use>
    </svg>
    <span class="ms-2 sidemenu-label">{{generalTranslation.OldInterface}}</span>
  </a>
</li>-->
<li class="d-block d-xl-none">
  <a (click)="navigateToWordpress()" title="{{generalTranslation.Homepage}}">
    <svg class="svgicon icon-education">
      <use xlink:href="assets/images/icons/symbol-defs.svg#web-edge"></use>
    </svg>
    <span class="ms-2 sidemenu-label">{{generalTranslation.Homepage}}</span>
  </a>
</li>
<li class="pt-4 d-xl-none border-top mobileQuicklinktxt">
  <h6 class="ms-3 sidemenu-label text-high-emphasis">
    Language Preference
  </h6>
</li>
<ifc-dropdown-menu [menuItems]="languages" [selectedMenu]="userPersistenceService.selectedLanguage"
  (onMenuClick)="onLanguageChange($event)" class="d-block d-xl-none mobileOnlydropdwn">
</ifc-dropdown-menu>
</ul>
}

<!-- Mobile Menubar starts here -->
@if (checkVersion() == 'v3.0.0') {
  <ul #MenuScrollBar style="height: 100vh" class="collapsible collapsible-accordion mt-0 d-block d-xl-none">
    <li class="no-collase" (click)="sideMenuClick('menuclose')">
      <a id="closeMenu" title="{{generalTranslation.CloseMenu}}">
        <svg class="svgicon icon-close">
          <use xlink:href="assets/images/icons/symbol-defs.svg#icon-close"></use>
        </svg>
        <span class="ms-2 sidemenu-label">&nbsp;</span>
      </a>
    </li>
    <li class="no-collase menu-expand-wrapper noMobileIcon" (click)="sideMenuClick('menuexpand')">
      <a id="expandMenu" title="{{generalTranslation.Expand}}">
        <svg class="svgicon icon-menuexpand">
          <use xlink:href="assets/images/icons/symbol-defs.svg#icon-menuexpand"></use>
        </svg>
        <span class="ms-2 sidemenu-label">&nbsp;</span>
      </a>
    </li>
    <li>
      <div class="MobileMenuAccordion">
        <mat-accordion [multi]="true">
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title><svg class="svgicon icon-homes">
                <use xlink:href="assets/images/icons/symbol-defs.svg#buildingType"></use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.BuildingType}}</span></mat-panel-title>
            </mat-expansion-panel-header>
            @if (isEdgeHomeInspector || userRole === 'Administrator') {
              <a [class.active]="toolType == 'HomeInspection'" routerLink="/project/homeInspection" (click)="redirect('HomeInspection','collapsed')" id="menuHomes"
                title="Home Prescriptive Certification">
                <svg class="svgicon icon-homeInspection">
                  <use xlink:href="assets/images/icons/symbol-defs.svg#icon-homeInspection"></use>
                </svg>
                <span class="ms-2 sidemenu-label">Home Prescriptive Certification</span>
              </a>
            }
            <a [class.active]="toolType == 'Homes'" routerLink="/project/allBuildings" (click)="redirect('Homes','collapsed')" id="menuHomes"
              title="{{generalTranslation.Homes}}">
              <svg class="svgicon icon-homes">
                <use xlink:href="assets/images/icons/symbol-defs.svg#icon-homes"></use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.Homes}}</span>
            </a>
            <a [class.active]="toolType == 'Apartments'" routerLink="/project/allBuildings" (click)="redirect('Apartments','collapsed')" id="menuApartments"
              title="{{generalTranslation.Apartments}}">
              <svg class="svgicon icon-education newsvg">
                <use xlink:href="assets/images/icons/symbol-defs.svg#icon-apartments"></use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.Apartments}}</span>
            </a>
            <a [class.active]="toolType == 'Serviced Apartment'" routerLink="/project/allBuildings" (click)="redirect('Serviced Apartment','collapsed')" id="menuServiceAparments"
              title="{{generalTranslation['Serviced Apartment']}}">
              <svg class="svgicon icon-education newsvg">
                <use xlink:href="assets/images/icons/symbol-defs.svg#service-apartments"></use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation['Serviced Apartment']}}</span>
            </a>
            <a [class.active]="toolType == 'Hotel'" routerLink="/project/allBuildings" (click)="redirect('Hotel','collapsed')" id="menuHospitality"
              title="{{generalTranslation.TitleHotels}}">
              <svg class="svgicon icon-hospitality">
                <use xlink:href="assets/images/icons/symbol-defs.svg#icon-hospitality">
                </use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.TitleHotels}}</span>
            </a>
            <a [class.active]="toolType == 'Resort'" routerLink="/project/allBuildings" (click)="redirect('Resort','collapsed')" id="menuResort"
              title="{{generalTranslation.Resort}}">
              <svg class="svgicon icon-education newsvg">
                <use xlink:href="assets/images/icons/symbol-defs.svg#icon-resort"></use>
              </svg>
              <span class="ms-2 sidemenu-label">
                {{generalTranslation.Resort}}
              </span>
            </a>
            <a [class.active]="toolType == 'Retail'" routerLink="/project/allBuildings" (click)="redirect('Retail','collapsed')" id="menuRetail"
                                       title="{{generalTranslation.Retail
                                            }}">
              <svg class="svgicon icon-retail">
                <use xlink:href="assets/images/icons/symbol-defs.svg#icon-retail"></use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.Retail}}</span>
            </a>
            <a [class.active]="toolType == 'Industrial'" routerLink="/project/allBuildings" (click)="redirect('Industrial','collapsed')" id="menuIndustry"
              title="{{generalTranslation.Industrial}}">
              <svg class="svgicon icon-education newsvg">
                <use xlink:href="assets/images/icons/symbol-defs.svg#icon-industry"></use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.Industrial}}</span>
            </a>
            <a [class.active]="toolType == 'Office'" routerLink="/project/allBuildings" (click)="redirect('Office','collapsed')" id="menuOffices"
              title="{{generalTranslation.Offices}}">
              <svg class="svgicon icon-offices">
                <use xlink:href="assets/images/icons/symbol-defs.svg#icon-offices"></use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.Offices}}</span>
            </a>
            <a [class.active]="toolType == 'Healthcare'" routerLink="/project/allBuildings" (click)="redirect('Healthcare','collapsed')" id="menuHealth"
              title="{{generalTranslation.Hospitals}}">
              <svg class="svgicon icon-health">
                <use xlink:href="assets/images/icons/symbol-defs.svg#icon-health"></use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.Hospitals}}</span>
            </a>
            <a [class.active]="toolType == 'Education'" routerLink="/project/allBuildings" (click)="redirect('Education','collapsed')" id="menuEducation"
              title="{{generalTranslation.Education}}" class="">
              <svg class="svgicon icon-education">
                <use xlink:href="assets/images/icons/symbol-defs.svg#icon-education"></use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.Education}}</span>
            </a>
            <a [class.active]="toolType == 'Mixed Use'" routerLink="/project/allBuildings" (click)="redirect('Mixed Use','collapsed')" id="menuMixuse"
              title="{{generalTranslation['Mixed Use']}}">
              <svg class="svgicon icon-education newsvg">
                <use xlink:href="assets/images/icons/symbol-defs.svg#icon-mixeduse"></use>
              </svg>
              <span class="ms-2 sidemenu-label">
                {{generalTranslation['Mixed Use']}}
              </span>
            </a>
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title><svg class="svgicon icon-homes">
                <use xlink:href="assets/images/icons/symbol-defs.svg#toolMobileIcon"></use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.Tools}}</span></mat-panel-title>
            </mat-expansion-panel-header>
            @if (!commonDataService.disableDashboard()) {
              <div class="hiddenForIpad">
                <a routerLinkActive="active" (click)="onDashboardClick();" id="menuHomes"
                  title="{{generalTranslation.Dashboard}}">
                  <svg class="svgicon icon-homes">
                    <use xlink:href="assets/images/icons/symbol-defs.svg#menuIconDashboard">
                    </use>
                  </svg>
                  <span class="ms-2 sidemenu-label">{{generalTranslation.Dashboard}}</span>
                </a>
              </div>
            }
            @if (isProjectMenu) {
              <div class="hiddenForIpad">
                <ifc-mobile-version-dropdown (onVersionChanged)="versionChanged($event)"
                  [versions]="versions" [selectedVersion]="selectedVersion"
                  class="mobileOnlydropdwn">
                </ifc-mobile-version-dropdown>
              </div>
            }
            @if (isProjectMenu) {
              <div class="hiddenForIpad">
                <ifc-mobile-filemenu-dropdown [fileMenuOptions]="fileMenuOptions"
                  (onMenuClick)="onFileMenuClick($event)" [projectAccess]="projectAccess"
                  [otherDetails]="otherDetails" class="mobileOnlydropdwn">
                </ifc-mobile-filemenu-dropdown>
              </div>
            }
            <!--<div>
            <a (click)="navigateToAlphaSite()" title="{{generalTranslation.OldInterface}}">
              <svg class="svgicon icon-education">
                <use xlink:href="assets/images/icons/symbol-defs.svg#switch-arrow">
                </use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.OldInterface}}</span>
            </a>
          </div>-->
          <div>
            <a (click)="navigateToWordpress()" title="{{generalTranslation.Homepage}}">
              <svg class="svgicon icon-education">
                <use xlink:href="assets/images/icons/symbol-defs.svg#web-edge"></use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.Homepage}}</span>
            </a>
          </div>
          <div class="hiddenForIpad">
            <a routerLinkActive="active" routerLink="/release-info"
              (click)="sideMenuClick('collapsed')" id="menuHomes"
              title="{{generalTranslation.Homes}}">
              <svg class="svgicon icon-homes">
                <use xlink:href="assets/images/icons/symbol-defs.svg#releaseNotIcon">
                </use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.ReleaseNote}}</span>
            </a>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="true" (click)="onScrollClick()" class="hiddenForIpad">
          <mat-expansion-panel-header>
            <mat-panel-title><svg class="svgicon icon-homes">
              <use xlink:href="assets/images/icons/symbol-defs.svg#languageMobleIcon"></use>
            </svg>
            <span class="ms-2 sidemenu-label">{{generalTranslation.Languages}}</span></mat-panel-title>
          </mat-expansion-panel-header>
          <ifc-mobile-language-dropdown [menuItems]="languages"
            [selectedMenu]="userPersistenceService.selectedLanguage"
            (onMenuClick)="onLanguageChange($event)" class="mobileOnlydropdwn">
          </ifc-mobile-language-dropdown>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </li>
</ul>
}

@if (checkVersion() != 'v3.0.0') {
  <ul #MenuScrollBar style="height: 100vh" class="collapsible collapsible-accordion mt-0 d-block d-xl-none">
    <li class="no-collase" (click)="sideMenuClick('menuclose')">
      <a id="closeMenu" title="{{generalTranslation.CloseMenu}}">
        <svg class="svgicon icon-close">
          <use xlink:href="assets/images/icons/symbol-defs.svg#icon-close"></use>
        </svg>
        <span class="ms-2 sidemenu-label">&nbsp;</span>
      </a>
    </li>
    <li class="no-collase menu-expand-wrapper noMobileIcon" (click)="sideMenuClick('menuexpand')">
      <a id="expandMenu" title="{{generalTranslation.Expand}}">
        <svg class="svgicon icon-menuexpand">
          <use xlink:href="assets/images/icons/symbol-defs.svg#icon-menuexpand"></use>
        </svg>
        <span class="ms-2 sidemenu-label">&nbsp;</span>
      </a>
    </li>
    <li>
      <div class="MobileMenuAccordion">
        <mat-accordion [multi]="true">
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title><svg class="svgicon icon-homes">
                <use xlink:href="assets/images/icons/symbol-defs.svg#buildingType"></use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.BuildingType}}</span></mat-panel-title>
            </mat-expansion-panel-header>
            @if (isEdgeHomeInspector ||isHpcCountryAdmin|| userRole === 'Administrator') {
              <a routerLinkActive="active" routerLink="/project/homeInspection"
                (click)="sideMenuClick('collapsed')" id="menuHomes"
                title="Home Prescriptive Certification">
                <svg class="svgicon icon-homeInspection">
                  <use xlink:href="assets/images/icons/symbol-defs.svg#icon-homeInspection"></use>
                </svg>
                <span class="ms-2 sidemenu-label">Home Prescriptive Certification</span>
              </a>
            }
            <a routerLinkActive="active" routerLink="/project/homes"
              (click)="sideMenuClick('collapsed')" id="menuHomes"
              title="{{generalTranslation.Homes}}">
              <svg class="svgicon icon-homes">
                <use xlink:href="assets/images/icons/symbol-defs.svg#icon-homes"></use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.Homes}}</span>
            </a>
            <a routerLinkActive="active" routerLink="/project/hospitality"
              (click)="sideMenuClick('collapsed')" id="menuHospitality"
              title="{{generalTranslation.TitleHotels}}">
              <svg class="svgicon icon-hospitality">
                <use xlink:href="assets/images/icons/symbol-defs.svg#icon-hospitality">
                </use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.TitleHotels}}</span>
            </a>
            <a routerLinkActive="active" routerLink="/project/retail"
              (click)="sideMenuClick('collapsed')" id="menuRetail"
              title="{{generalTranslation.Retail}}">
              <svg class="svgicon icon-retail">
                <use xlink:href="assets/images/icons/symbol-defs.svg#icon-retail"></use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.Retail}}</span>
            </a>
            <a routerLinkActive="active" routerLink="/project/offices"
              (click)="sideMenuClick('collapsed')" id="menuOffices"
              title="{{generalTranslation.Offices}}">
              <svg class="svgicon icon-offices">
                <use xlink:href="assets/images/icons/symbol-defs.svg#icon-offices"></use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.Offices}}</span>
            </a>
            <a routerLinkActive="active" routerLink="/project/hospitals"
              (click)="sideMenuClick('collapsed')" id="menuHealth"
              title="{{generalTranslation.Hospitals}}">
              <svg class="svgicon icon-health">
                <use xlink:href="assets/images/icons/symbol-defs.svg#icon-health"></use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.Hospitals}}</span>
            </a>
            <a routerLinkActive="active" routerLink="/project/education" id="menuEducation"
              title="{{generalTranslation.Education}}" class=""
              (click)="sideMenuClick('collapsed')">
              <svg class="svgicon icon-education">
                <use xlink:href="assets/images/icons/symbol-defs.svg#icon-education"></use>
              </svg>
              <span class="ms-2 sidemenu-label">{{generalTranslation.Education}}</span>
            </a>
            <!--<a routerLinkActive="active" href="javascript:void(0)" id="menuAllBuildings"
            title="{{generalTranslation.Education}}" class=""
            (click)="sideMenuClick('collapsed')">
            <svg class="svgicon icon-education">
              <use xlink:href="assets/images/icons/symbol-defs.svg#icon-education"></use>
            </svg>
            <span class="ms-2 sidemenu-label">{{generalTranslation.Education}}</span>
          </a>-->
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title><svg class="svgicon icon-homes">
              <use xlink:href="assets/images/icons/symbol-defs.svg#toolMobileIcon"></use>
            </svg>
            <span class="ms-2 sidemenu-label">{{generalTranslation.Tools}}</span></mat-panel-title>
          </mat-expansion-panel-header>
          @if (!commonDataService.disableDashboard()) {
            <div class="hiddenForIpad">
              <a routerLinkActive="active" (click)="onDashboardClick();" id="menuHomes"
                title="{{generalTranslation.Dashboard}}">
                <svg class="svgicon icon-homes">
                  <use xlink:href="assets/images/icons/symbol-defs.svg#menuIconDashboard">
                  </use>
                </svg>
                <span class="ms-2 sidemenu-label">{{generalTranslation.Dashboard}}</span>
              </a>
            </div>
          }
          @if (isProjectMenu) {
            <div class="hiddenForIpad">
              <ifc-mobile-version-dropdown (onVersionChanged)="versionChanged($event)"
                [versions]="versions" [selectedVersion]="selectedVersion"
                class="mobileOnlydropdwn">
              </ifc-mobile-version-dropdown>
            </div>
          }
          @if (isProjectMenu) {
            <div class="hiddenForIpad">
              <ifc-mobile-filemenu-dropdown [fileMenuOptions]="fileMenuOptions"
                (onMenuClick)="onFileMenuClick($event)" [projectAccess]="projectAccess"
                [otherDetails]="otherDetails" class="mobileOnlydropdwn">
              </ifc-mobile-filemenu-dropdown>
            </div>
          }
          <!--<div>
          <a (click)="navigateToAlphaSite()" title="{{generalTranslation.OldInterface}}">
            <svg class="svgicon icon-education">
              <use xlink:href="assets/images/icons/symbol-defs.svg#switch-arrow">
              </use>
            </svg>
            <span class="ms-2 sidemenu-label">{{generalTranslation.OldInterface}}</span>
          </a>
        </div>-->
        <div>
          <a (click)="navigateToWordpress()" title="{{generalTranslation.Homepage}}">
            <svg class="svgicon icon-education">
              <use xlink:href="assets/images/icons/symbol-defs.svg#web-edge"></use>
            </svg>
            <span class="ms-2 sidemenu-label">{{generalTranslation.Homepage}}</span>
          </a>
        </div>
        <div class="hiddenForIpad">
          <a routerLinkActive="active" routerLink="/release-info"
            (click)="sideMenuClick('collapsed')" id="menuHomes"
            title="{{generalTranslation.Homes}}">
            <svg class="svgicon icon-homes">
              <use xlink:href="assets/images/icons/symbol-defs.svg#releaseNotIcon">
              </use>
            </svg>
            <span class="ms-2 sidemenu-label">{{generalTranslation.ReleaseNote}}</span>
          </a>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="true" (click)="onScrollClick()" class="hiddenForIpad">
        <mat-expansion-panel-header>
          <mat-panel-title><svg class="svgicon icon-homes">
            <use xlink:href="assets/images/icons/symbol-defs.svg#languageMobleIcon"></use>
          </svg>
          <span class="ms-2 sidemenu-label">{{generalTranslation.Languages}}</span></mat-panel-title>
        </mat-expansion-panel-header>
        <ifc-mobile-language-dropdown [menuItems]="languages"
          [selectedMenu]="userPersistenceService.selectedLanguage"
          (onMenuClick)="onLanguageChange($event)" class="mobileOnlydropdwn">
        </ifc-mobile-language-dropdown>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</li>
</ul>
}
<!-- Mobile Menubar starts here -->
</div>
<!--/. Side navigation links -->
<div class="sidenav-bg mask-strong"></div>
</div>
<!-- Sidenav overlay -->
<div id="sidenav-overlay" (click)="overlayClick()"></div>
<!--/. Sidebar navigation -->
<!-- Navbar -->
<header>
  <nav class="navbar navbar-toggleable-md navbar-expand-lg scrolling-navbar double-nav p-0 ifc-header fixed-top">
    <div class="navbar-container">
      <!-- SideNav slide-out button -->
      <div class="float-start align-middle">
        <a (click)="showSidenave()" class="hidden-nav border-right border-mild-grey px-4 px-md-4 py-3" title="{{generalTranslation.Menu}}"
          id="menuShowSidenave">
          <div class="text-headergrey">
            <i class="fa fa-bars"></i><!-- <span class="ms-2 body2 hide-on-ipad-portrait text-uppercase"></span>{{generalTranslation.Menu}} -->
          </div>
        </a>
      </div>
      <!--/. SideNav slide-out button -->
    </div>
    <div class="navbar-brand-wrapper">
      <!-- Breadcrumb-->
      <div class="header-logo me-auto">
        <a (click)="navigateToWordpress()"><img src="assets/images/header-logo-full.png"></a>
      </div>
      <!--/. Breadcrumb-->
    </div>
    <div class="navbar-links">
      <ul class="nav navbar-nav nav-flex-icons ms-auto ie-double-nav">
        <!--<li class="nav-item border-right d-none d-xl-block px-4 pt-4">
        <a class="alphaBetaLink" (click)="navigateToAlphaSite()">{{generalTranslation.OldInterface}}</a>
      </li>-->
      <!--<li class="nav-item border-right d-none d-xl-block px-4 pt-4">
      <a class="alphaBetaLink" (click)="navigateToQuoteRequest()" title="Request a Quote">
        Request a Quote
      </a>
    </li>-->
    @if (checkVersion() == 'v3.0.0') {
      <li class="nav-item switch-nav-setting d-none d-xl-block px-4 pt-4 border-right">
        <ifc-cvswitch cssClass="primary-switch" [title]="toggleTitle"></ifc-cvswitch>
      </li>
    }
    <ifc-dropdown-menu [menuItems]="languages" [selectedMenu]="userPersistenceService.selectedLanguage"
    (onMenuClick)="onLanguageChange($event)"></ifc-dropdown-menu>
    <li class="nav-item border-right border-left d-none d-xl-block px-4 pt-4">
      <a (click)="navigateToWordpress()" class="cursor-pointer">{{generalTranslation.Homepage}}</a>
    </li>
    <ifc-notification-dropdown></ifc-notification-dropdown>
    @if (!authservice.isAuthenticated()) {
      <li class="nav-item dropdown btn-group border-left border-mild-grey px-4 pt-1"
        >
        <a class="toggle">
          @if (!authservice.isAuthenticated()) {
            <span (click)="loginOrOut()"
            id="linkLoginRegister">{{userPersistenceService.generalTranslation.SignIn}}</span>
            } <span class="hide-on-ipad-portrait ps-2">{{localStorageService.get(constants.USER_FULL_NAME)}}</span>
          </a>
        </li>
      }
      @if (authservice.isAuthenticated()) {
        <li class="nav-item dropdown btn-group border-left border-mild-grey ps-3 pe-0 pt-1 mobileProfileDropdown"
          >
          <a [matMenuTriggerFor]="userMenu" class="d-flex mobileLoginLink cursor-pointer"
            (menuOpened)="onUserMenuOpened()"
            (menuClosed)="onUserMenuClosed()"
            id="userMenuTrigger"
            #profileMenuTrigger>
            @if (authservice.isAuthenticated()) {
              <div class="smallProfileImage">
                @if (profileImagePath) {
                  <img [src]="profileImagePath">
                }
              </div>
            }
            <span class="hide-on-ipad-portrait ps-2 text-truncate profileNameTxt" style="max-width:150px">{{localStorageService.get(constants.USER_FULL_NAME)}}</span>
            <i class="fa fa-angle-down ms-2 align-self-center"></i>
          </a>
          <mat-menu #userMenu="matMenu" panelClass="user-profile-menu" xPosition="before" yPosition="below" [overlapTrigger]="false">
            <div class="profileImageLink" (click)="$event.stopPropagation()">
              <div class="rounded border thumbImage" (click)="openImageCropper()">
                @if (profileImagePath) {
                  <img [src]="profileImagePath">
                }
              </div>
              <div class="profileNameTxt">
                <span class="">
                  <div class="text-center">Hello, </div>
                  <div class="text-center">
                    {{localStorageService.get(constants.USER_FULL_NAME)}}
                  </div>
                </span>
              </div>
            </div>
            <button mat-menu-item class="profile-menu-item" (click)="openUserProfile()" id="linkProfile">
              <span>Profile</span>
            </button>
            <button mat-menu-item class="profile-menu-item" (click)="onDashboardClick()" id="linkDashboard">
              <span>Dashboard</span>
            </button>
            @if (userRole == 'Administrator' || userRole == 'Country Admin') {
              <button mat-menu-item class="profile-menu-item"
                (click)="openMyProject()"
                id="linkMyProjects">
                <span>Existing Projects</span>
              </button>
            }
            @if (userRole == 'Administrator' || edgeTrinerAccess || edgeFacultyAccess) {
              <button mat-menu-item class="profile-menu-item"
                (click)="openPrometric()" id="linkEdgeExam">
                <span>EDGE Exam</span>
              </button>
            }
            @if (isStaticDashboardAccess) {
              <button mat-menu-item class="profile-menu-item"
                (click)="openDatabase()" id="linkDatabase">
                <span>Database</span>
              </button>
            }
            @if (userRole == 'Country Admin'  || edgeTrinerAccess == true || edgeFacultyAccess && (userRole != 'Certifier Admin' && userRole != 'Administrator')) {
              <button mat-menu-item class="profile-menu-item"
                (click)="openDirectoryOfEdgeExpert()" id="linkDirectoryOfEdgeExpert">
                <span>Directory of EDGE Experts</span>
              </button>
            }
            @if (userRole == 'Certifier Admin' || userRole == 'Administrator') {
              <button mat-menu-item class="profile-menu-item"
                (click)="openEdgeExpertAndAuditor()" id="linkEdgeExpertAndAuditor">
                <span>EDGE Experts and Auditors</span>
              </button>
            }
            @if (userRole == 'Administrator') {
              <button mat-menu-item class="profile-menu-item"
                (click)="openUserRoleConfig()" id="linkUserRoleConfig">
                <span>User Role Configuration</span>
              </button>
            }
            @if (isHpcAdmin) {
              <button mat-menu-item class="profile-menu-item"
                (click)="openHpcRoleConfig()" id="linkHpcRoleConfig">
                <span>HPC Role Configuration</span>
              </button>
            }
            @if (userRole == 'Administrator' || isHPCConfigurationEnable) {
              <button mat-menu-item class="profile-menu-item"
                (click)="openHpcPartnerConfig()" id="linkHPCPartnerConfig">
                <span>HPC Partner Configuration</span>
              </button>
            }
            @if (userRole == 'Administrator') {
              <button mat-menu-item class="profile-menu-item"
                (click)="onNotificationCenterClick()" id="linkNotificationCenter">
                <span>Notification Center</span>
              </button>
            }
            <button mat-menu-item class="profile-menu-item" (click)="openChangePasswordModal()" id="linkChangePassword">
              <span>Change Password</span>
            </button>
            @if (isOrganizationData || userRole == 'Administrator' ) {
              <button mat-menu-item class="profile-menu-item"
                (click)="navigateToOrganization()" id="linkOrganization">
                <span>Organization(s)</span>
              </button>
            }
            @if (userRole == 'Administrator' || isServiceTicketAccess || isEnableServiceRequest) {
              <button mat-menu-item class="profile-menu-item"
                (click)="ServiceRequest()"
                id="linkServiceRequest">
                <span>Service Request</span>
              </button>
            }
            <!--Adding VersionManagement as Delta Change from UI_PROD_28JUN20266-->
            @if (userRole === 'Administrator') {
            <button mat-menu-item class="profile-menu-item" (click)="VersionManagement()" id="linkVersionManagement">
              <span>Version Management</span>
            </button>
            }
            <button mat-menu-item class="profile-menu-item" (click)="loginOrOut()" id="linkLogout">
              <span>Sign Out</span>
            </button>
          </mat-menu>
        </li>
      }
    </ul>
  </div>
</nav>
</header>
<!--/.Double navigation-->
